




import mon_background from './frames/background_digimon_evo.png';
import dual_background from './frames/background_dual.png';
import mega_background from './frames/background_digimon.png';
import egg_background from './frames/background_egg.png';
import option_background from './frames/background_option.png';
import tamer_background from './frames/background_tamer.png';
import tamer_dp_background from './frames/background_tamer_dp.png';

import mon_background_nocost from './frames/background_digimon_evo_nocost.png';
import mega_background_nocost from './frames/background_digimon_nocost.png';
import egg_background_nocost from './frames/background_egg_nocost.png';
import option_background_nocost from './frames/background_option_nocost.png';
import tamer_background_nocost from './frames/background_tamer_nocost.png';

import ace_red from './frames/backgrounds/red-ace.png';
import ace_blue from './frames/backgrounds/blue-ace.png';
import ace_yellow from './frames/backgrounds/yellow-ace.png';
import ace_green from './frames/backgrounds/green-ace.png';
import ace_black from './frames/backgrounds/black-ace.png';
import ace_purple from './frames/backgrounds/purple-ace.png';
import ace_white from './frames/backgrounds/white-ace.png';


import dual_red from './frames/backgrounds/red-dual.png';
import dual_blue from './frames/backgrounds/blue-dual.png';
import dual_yellow from './frames/backgrounds/yellow-dual.png';
import dual_green from './frames/backgrounds/green-dual.png';
import dual_black from './frames/backgrounds/black-dual.png';
import dual_purple from './frames/backgrounds/purple-dual.png';
import dual_white from './frames/backgrounds/white-dual.png';

import _cost from './frames/cost.png';
import _cost_egg from './frames/cost-egg.png';
import _cost_dual from './frames/cost-dual.png';
import _cost_blank from './frames/cost-none.png';
import _cost_option from './frames/cost-option.png';

import _cost_color_red from './frames/cost_color_red.png';
import _cost_color_blue from './frames/cost_color_blue.png';
import _cost_color_yellow from './frames/cost_color_yellow.png';
import _cost_color_green from './frames/cost_color_green.png';
import _cost_color_purple from './frames/cost_color_purple.png';
import _cost_color_black from './frames/cost_color_black.png';
import _cost_color_white from './frames/cost_color_white.png';


// we use the tamer inherited for both tamer and monster, even though
// it's bigger, and it just overflows the bottom of the image
/*import _bottom_evo_red from './frames/bottom_evo_red.png';
import _bottom_evo_blue from './frames/bottom_evo_blue.png';
import _bottom_evo_yellow from './frames/bottom_evo_yellow.png';
import _bottom_evo_green from './frames/bottom_evo_green.png';
import _bottom_evo_purple from './frames/bottom_evo_purple.png';
import _bottom_evo_black from './frames/bottom_evo_black.png';
import _bottom_evo_white from './frames/bottom_evo_white.png';*/

import _bottom_evo_red from './frames/inherits/bottom_red_evo_tamer.png';
import _bottom_evo_blue from './frames/inherits/bottom_blue_evo_tamer.png';
import _bottom_evo_yellow from './frames/inherits/bottom_yellow_evo_tamer.png';
import _bottom_evo_green from './frames/inherits/bottom_green_evo_tamer.png';
import _bottom_evo_purple from './frames/inherits/bottom_purple_evo_tamer.png';
import _bottom_evo_black from './frames/inherits/bottom_black_evo_tamer.png';
import _bottom_evo_white from './frames/inherits/bottom_white_evo_tamer.png';

import _bottom_evo_egg_red from './frames/inherits/bottom_red_digitama.png';
import _bottom_evo_egg_blue from './frames/inherits/bottom_blue_digitama.png';
import _bottom_evo_egg_yellow from './frames/inherits/bottom_yellow_digitama.png';
import _bottom_evo_egg_green from './frames/inherits/bottom_green_digitama.png';
import _bottom_evo_egg_purple from './frames/inherits/bottom_purple_digitama.png';
import _bottom_evo_egg_black from './frames/inherits/bottom_black_digitama.png';
import _bottom_evo_egg_white from './frames/inherits/bottom_white_digitama.png';


import _bottom_red from './frames/bottom_red.png';
import _bottom_blue from './frames/bottom_blue.png';
import _bottom_yellow from './frames/bottom_yellow.png';
import _bottom_green from './frames/bottom_green.png';
import _bottom_purple from './frames/bottom_purple.png';
import _bottom_black from './frames/bottom_black.png';
import _bottom_white from './frames/bottom_white.png';

/*
import _bottom_ace_red from './frames/inherits/bottom_red_evo_ace.png';
import _bottom_ace_blue from './frames/inherits/bottom_blue_evo_ace.png';
import _bottom_ace_yellow from './frames/inherits/bottom_yellow_evo_ace.png';
import _bottom_ace_green from './frames/inherits/bottom_green_evo_ace.png';
import _bottom_ace_purple from './frames/inherits/bottom_purple_evo_ace.png';
import _bottom_ace_black from './frames/inherits/bottom_black_evo_ace.png';
import _bottom_ace_white from './frames/inherits/bottom_white_evo_ace.png';
*/

//import _ace_box from './frames/ace-empty.png';
import _ace_box from './frames/ace-blank.png';
import _arts_box from './frames/arts-blank.png';

import _ace_logo from './frames/ACE.png';

import _inherited_sec_red from './frames/inherits/bottom_red_security.png';
import _inherited_sec_blue from './frames/inherits/bottom_blue_security.png';
import _inherited_sec_yellow from './frames/inherits/bottom_yellow_security.png';
import _inherited_sec_green from './frames/inherits/bottom_green_security.png';
import _inherited_sec_purple from './frames/inherits/bottom_purple_security.png';
import _inherited_sec_black from './frames/inherits/bottom_black_security.png';
import _inherited_sec_white from './frames/inherits/bottom_white_security.png';

import _inherited_sec_mon_red from './frames/inherits/bottom_red_mon_security.png';
import _inherited_sec_mon_blue from './frames/inherits/bottom_blue_mon_security.png';
import _inherited_sec_mon_yellow from './frames/inherits/bottom_yellow_mon_security.png';
import _inherited_sec_mon_green from './frames/inherits/bottom_green_mon_security.png';
import _inherited_sec_mon_purple from './frames/inherits/bottom_purple_mon_security.png';
import _inherited_sec_mon_black from './frames/inherits/bottom_black_mon_security.png';
import _inherited_sec_mon_white from './frames/inherits/bottom_white_mon_security.png';


import _bottom_plain_red from './frames/inherits/bottom_plain_red.png';
import _bottom_plain_blue from './frames/inherits/bottom_plain_blue.png';
import _bottom_plain_yellow from './frames/inherits/bottom_plain_yellow.png';
import _bottom_plain_green from './frames/inherits/bottom_plain_green.png';
import _bottom_plain_purple from './frames/inherits/bottom_plain_purple.png';
import _bottom_plain_black from './frames/inherits/bottom_plain_black.png';
import _bottom_plain_white from './frames/inherits/bottom_plain_white.png';


import _bottom_property_white from './frames/bottom_digimon_properties_white.png';
import _bottom_property_black from './frames/bottom_digimon_properties_black.png';


import _border_red from './frames/border_red.png';
import _border_blue from './frames/border_blue.png';
import _border_yellow from './frames/border_yellow.png';
import _border_green from './frames/border_green.png';
import _border_purple from './frames/border_purple.png';
import _border_black from './frames/border_black.png';
import _border_white from './frames/border_white.png';


import basic_red from './frames/basic-red.png';
import basic_blue from './frames/basic-blue.png';
import basic_yellow from './frames/basic-yellow.png';
import basic_green from './frames/basic-green.png';
import basic_purple from './frames/basic-purple.png';
import basic_black from './frames/basic-black.png';
import basic_white from './frames/basic-white.png';


// normal mon outlines
import outline_red from './frames/outline-red.png';
import outline_blue from './frames/outline-blue.png';
import outline_yellow from './frames/outline-yellow.png';
import outline_green from './frames/outline-green.png';
import outline_purple from './frames/outline-purple.png';
import outline_black from './frames/outline-black.png';
import outline_white from './frames/outline-white.png';

import outline_red_nocost from './frames/outline-red_nocost.png';
import outline_blue_nocost from './frames/outline-blue_nocost.png';
import outline_yellow_nocost from './frames/outline-yellow_nocost.png';
import outline_green_nocost from './frames/outline-green_nocost.png';
import outline_purple_nocost from './frames/outline-purple_nocost.png';
import outline_black_nocost from './frames/outline-black_nocost.png';
import outline_white_nocost from './frames/outline-white_nocost.png';


import outline_option from './frames/outline-option.png';
import outline_option_nocost from './frames/outline-option-nocost.png';

import outline_egg_red from './frames/new-egg-red.png';
import outline_egg_blue from './frames/new-egg-blue.png';
import outline_egg_yellow from './frames/new-egg-yellow.png';
import outline_egg_green from './frames/new-egg-green.png';
import outline_egg_purple from './frames/new-egg-purple.png';
import outline_egg_black from './frames/new-egg-black.png';
import outline_egg_white from './frames/new-egg-white.png';

import outline_egg_red_nocost from'./frames/new-egg-red_nocost.png';
import outline_egg_blue_nocost from'./frames/new-egg-blue_nocost.png';
import outline_egg_yellow_nocost from'./frames/new-egg-yellow_nocost.png';
import outline_egg_green_nocost from'./frames/new-egg-green_nocost.png';
import outline_egg_purple_nocost from'./frames/new-egg-purple_nocost.png';
import outline_egg_black_nocost from'./frames/new-egg-black_nocost.png';
import outline_egg_white_nocost from'./frames/new-egg-white_nocost.png';


//import outline_nocost_red from './frames/new-nocost-red.png';
//import outline_nocost_blue from './frames/new-nocost-blue.png';
//import outline_nocost_yellow from './frames/new-nocost-yellow.png';
import outline_nocost_green from './frames/outline-nocost-green.png';
//import outline_nocost_purple from './frames/new-nocost-purple.png';
//import outline_nocost_black from './frames/new-nocost-black.png';
//import outline_nocost_white from './frames/new-nocost-white.png';



import outline_tamer_red from './frames/tamer/outline-tamer-red.png';
import outline_tamer_blue from './frames/tamer/outline-tamer-blue.png';
import outline_tamer_yellow from './frames/tamer/outline-tamer-yellow.png';
import outline_tamer_green from './frames/tamer/outline-tamer-green.png';
import outline_tamer_purple from './frames/tamer/outline-tamer-purple.png';
import outline_tamer_black from './frames/tamer/outline-tamer-black.png';
import outline_tamer_white from './frames/tamer/outline-tamer-white.png';

import outline_tamer_red_nocost from './frames/tamer/outline-tamer-red_nocost.png';
import outline_tamer_blue_nocost from './frames/tamer/outline-tamer-blue_nocost.png';
import outline_tamer_yellow_nocost from './frames/tamer/outline-tamer-yellow_nocost.png';
import outline_tamer_green_nocost from './frames/tamer/outline-tamer-green_nocost.png';
import outline_tamer_purple_nocost from './frames/tamer/outline-tamer-purple_nocost.png';
import outline_tamer_black_nocost from './frames/tamer/outline-tamer-black_nocost.png';
import outline_tamer_white_nocost from './frames/tamer/outline-tamer-white_nocost.png';




import classic_red from './frames/classic-red.png';
import classic_blue from './frames/classic-blue.png';
import classic_yellow from './frames/classic-yellow.png';
import classic_green from './frames/classic-green.png';
import classic_purple from './frames/classic-purple.png';
import classic_black from './frames/classic-black.png';
import classic_white from './frames/classic-white.png';


import egg_red from './frames/egg-red.png';
import egg_blue from './frames/egg-blue.png';
import egg_yellow from './frames/egg-yellow.png';
import egg_green from './frames/egg-green.png';
import egg_purple from './frames/egg-purple.png';
import egg_black from './frames/egg-black.png';
import egg_white from './frames/egg-white.png';


import option_red from './frames/option-red.png';
import option_blue from './frames/option-blue.png';
import option_yellow from './frames/option-yellow.png';
import option_green from './frames/option-green.png';
import option_purple from './frames/option-purple.png';
import option_black from './frames/option-black.png';
import option_white from './frames/option-white.png';

import effectbox_red from './frames/effects/effectbox_red.png';
import effectbox_blue from './frames/effects/effectbox_blue.png';
import effectbox_yellow from './frames/effects/effectbox_yellow.png';
import effectbox_green from './frames/effects/effectbox_green.png';
import effectbox_purple from './frames/effects/effectbox_purple.png';
import effectbox_black from './frames/effects/effectbox_black.png';
import effectbox_white from './frames/effects/effectbox_white.png';


import tamer_red from './frames/tamer-red1.png';
import tamer_blue from './frames/tamer-blue1.png';
import tamer_yellow from './frames/tamer-yellow1.png';
import tamer_green from './frames/tamer-green1.png';
import tamer_purple from './frames/tamer-purple1.png';
import tamer_black from './frames/tamer-black1.png';
import tamer_white from './frames/tamer-white1.png';

/* Pre-BT14
import evo_red from './frames/evo-red_out.png';
import evo_blue from './frames/evo-blue_out.png';
import evo_yellow from './frames/evo-yellow_out.png';
import evo_green from './frames/evo-green_out.png';
import evo_purple from './frames/evo-purple_out.png';
import evo_black from './frames/evo-black_out.png';
import evo_white from './frames/evo-white_out.png';
*/

// new evo
import _cost_evo from './frames/evos/evolution.png';
import _cost_evo_plain from './frames/evos/evolution_plain.png';

// circle
import new_evo_red from './frames/evos/evo_red.png';
import new_evo_blue from './frames/evos/evo_blue.png';
import new_evo_yellow from './frames/evos/evo_yellow.png';
import new_evo_green from './frames/evos/evo_green.png';
import new_evo_purple from './frames/evos/evo_purple.png';
import new_evo_black from './frames/evos/evo_black.png';
import new_evo_white from './frames/evos/evo_white.png';
import new_evo_all from './frames/evos/evo_rainbow.png';

import new_evo2_red from './frames/evos/evo2_red.png';
import new_evo2_blue from './frames/evos/evo2_blue.png';
import new_evo2_yellow from './frames/evos/evo2_yellow.png';
import new_evo2_green from './frames/evos/evo2_green.png';
import new_evo2_purple from './frames/evos/evo2_purple.png';
import new_evo2_black from './frames/evos/evo2_black.png';
import new_evo2_white from './frames/evos/evo2_white.png';


import wedge_evo_red from './frames/evos/cost_evo_red.png';
import wedge_evo_blue from './frames/evos/cost_evo_blue.png';
import wedge_evo_yellow from './frames/evos/cost_evo_yellow.png';
import wedge_evo_green from './frames/evos/cost_evo_green.png';
import wedge_evo_purple from './frames/evos/cost_evo_purple.png';
import wedge_evo_black from './frames/evos/cost_evo_black.png';
import wedge_evo_white from './frames/evos/cost_evo_white.png';
import wedge_evo_all from './frames/evos/cost_evo_all.png';



import _dna_red from './frames/dna_box_red.png';
import _dna_blue from './frames/dna_box_blue.png';
import _dna_yellow from './frames/dna_box_yellow.png';
import _dna_green from './frames/dna_box_green.png';
import _dna_purple from './frames/dna_box_purple.png';
import _dna_black from './frames/dna_box_black.png';
import _dna_white from './frames/dna_box_white.png';
import _dna_all from './frames/dna_box_all.png';

import _foil from './frames/foil.png';
import _gold from './frames/gold.png';

import _bubble from './frames/bubble.png';
import _doublebubble from './frames/doublebubble.png';
import _linkdp from './frames/linkdp.png';

import pen from './frames/pen.png';


import _redline from   './frames/lines/redline.png';
import _blueline from  './frames/lines/blueline.png';
import _yellowline from './frames/lines/yellowline.png';
import _greenline from './frames/lines/greenline.png';
import _blackline from './frames/lines/blackline.png';
import _purpleline from './frames/lines/purpleline.png';
import _whiteline from './frames/lines/whiteline.png';



export const ace_backgrounds = {
  'red': ace_red,
  'blue': ace_blue,
  'yellow': ace_yellow,
  'green': ace_green,
  'purple': ace_purple,
  'black': ace_black,
  'white': ace_white
}
export const dual_backgrounds = {
  'red': dual_red,
  'blue': dual_blue,
  'yellow': dual_yellow,
  'green': dual_green,
  'purple': dual_purple,
  'black': dual_black,
  'white': dual_white
}

export const new_evo_circles = {
  'red': new_evo_red,
  'blue': new_evo_blue,
  'yellow': new_evo_yellow,
  'green': new_evo_green,
  'purple': new_evo_purple,
  'black': new_evo_black,
  'white': new_evo_white,
  'all': new_evo_all,
}

export const new_evo_wedges = {
  'red': wedge_evo_red,
  'blue': wedge_evo_blue,
  'yellow': wedge_evo_yellow,
  'green': wedge_evo_green,
  'purple': wedge_evo_purple,
  'black': wedge_evo_black,
  'white': wedge_evo_white,
  'all': wedge_evo_all,
}

// unused now
export const new_evo2_circles = {
  'red': new_evo2_red,
  'blue': new_evo2_blue,
  'yellow': new_evo2_yellow,
  'green': new_evo2_green,
  'purple': new_evo2_purple,
  'black': new_evo2_black,
  'white': new_evo2_white,
}

// gradient for special backgrounds
export const redline = new Image(); redline.src = _redline;
export const blueline = new Image(); blueline.src = _blueline;
export const yellowline = new Image(); yellowline.src = _yellowline;
export const greenline = new Image(); greenline.src = _greenline;
export const blackline = new Image();  blackline.src = _blackline;
export const purpleline = new Image(); purpleline.src = _purpleline;
export const whiteline = new Image(); whiteline.src = _whiteline;

export const lines = {
  'red': redline,
  'blue': blueline,
  'yellow': yellowline,
  'green': greenline,
  'black': blackline,
  'purple': purpleline,
  'white': whiteline,
}

let foil = new Image(); foil.src = _foil;
let gold = new Image(); gold.src = _gold;
let bubble = new Image(); bubble.src = _bubble;
let doublebubble = new Image(); doublebubble.src = _doublebubble;
let linkdp = new Image(); linkdp.src = _linkdp;

let dna_red = new Image(); dna_red.src = _dna_red;
let dna_blue = new Image(); dna_blue.src = _dna_blue;
let dna_yellow = new Image(); dna_yellow.src = _dna_yellow;
let dna_green = new Image(); dna_green.src = _dna_green;
let dna_purple = new Image(); dna_purple.src = _dna_purple;
let dna_black = new Image(); dna_black.src = _dna_black;
let dna_white = new Image(); dna_white.src = _dna_white;
let dna_all = new Image(); dna_all.src = _dna_all;




export const dna_boxes = {
  'red': dna_red,
  'blue': dna_blue,
  'yellow': dna_yellow,
  'green': dna_green,
  'purple': dna_purple,
  'black': dna_black,
  'white': dna_white,
  'all': dna_all,
}

//export const background;

let cost = new Image(); cost.src = _cost;
let cost_egg = new Image(); cost_egg.src = _cost_egg;
let cost_dual = new Image(); cost_dual.src = _cost_dual;
let cost_blank = new Image(); cost_blank.src = _cost_blank;
let cost_option = new Image(); cost_option.src = _cost_option;
let cost_evo = new Image(); cost_evo.src = _cost_evo;
let cost_evo_plain = new Image(); cost_evo_plain.src = _cost_evo_plain;

let arts_box = new Image(); arts_box.src = _arts_box;
let ace_box = new Image(); ace_box.src = _ace_box;
let ace_logo = new Image(); ace_logo.src = _ace_logo;


let cost_red = new Image(); cost_red.src = _cost_color_red;
let cost_blue = new Image(); cost_blue.src = _cost_color_blue;
let cost_yellow = new Image(); cost_yellow.src = _cost_color_yellow;
let cost_green = new Image(); cost_green.src = _cost_color_green;
let cost_purple = new Image(); cost_purple.src = _cost_color_purple;
let cost_black = new Image(); cost_black.src = _cost_color_black;
let cost_white = new Image(); cost_white.src = _cost_color_white;

export const costs = {
  'red': cost_red,
  'blue': cost_blue,
  'yellow': cost_yellow,
  'green': cost_green,
  'purple': cost_purple,
  'black': cost_black,
  'white': cost_white,
}



let bottom_property_white = new Image(); bottom_property_white.src = _bottom_property_white;
let bottom_property_black = new Image(); bottom_property_black.src = _bottom_property_black;

let pen_img = new Image(); pen_img.src = pen;

// these backgrounds are used all the time and should be pre-loaded
export {
  mon_background, dual_background, mega_background, 
  egg_background, option_background, tamer_background, tamer_dp_background,
  mon_background_nocost, mega_background_nocost, egg_background_nocost, option_background_nocost, tamer_background_nocost,
  cost, cost_egg, cost_dual, cost_blank, cost_option, cost_evo, cost_evo_plain,
  outline_option, outline_option_nocost, 
  arts_box, ace_box, ace_logo,
  bottom_property_white, bottom_property_black,
  foil, gold, bubble, doublebubble, linkdp,
  pen_img
};

export const basics = {
  'red': basic_red,
  'blue': basic_blue,
  'yellow': basic_yellow,
  'green': basic_green,
  'purple': basic_purple,
  'black': basic_black,
  'white': basic_white,
}


export const outlines = {
  'red': outline_red,
  'blue': outline_blue,
  'yellow': outline_yellow,
  'green': outline_green,
  'purple': outline_purple,
  'black': outline_black,
  'white': outline_white,
}
export const outlines_nocost = {
  'red': outline_red_nocost,
  'blue': outline_blue_nocost,
  'yellow': outline_yellow_nocost,
  'green': outline_green_nocost,
  'purple': outline_purple_nocost,
  'black': outline_black_nocost,
  'white': outline_white_nocost,
}

export const outlines_egg = {
  'red': outline_egg_red,
  'blue': outline_egg_blue,
  'yellow': outline_egg_yellow,
  'green': outline_egg_green,
  'purple': outline_egg_purple,
  'black': outline_egg_black,
  'white': outline_egg_white,
}

export const outlines_egg_nocost = {
  'red': outline_egg_red_nocost,
  'blue': outline_egg_blue_nocost,
  'yellow': outline_egg_yellow_nocost,
  'green': outline_egg_green_nocost,
  'purple': outline_egg_purple_nocost,
  'black': outline_egg_black_nocost,
  'white': outline_egg_white_nocost,
}


export const DELETE_outlines_nocost = {
  /*
  'red': outline_nocost_red,
  'blue': outline_nocost_blue,
  'yellow': outline_nocost_yellow,*/
  'green': outline_nocost_green,
  /*
  'purple': outline_nocost_purple,
  'black': outline_nocost_black,
  'white': outline_nocost_white,
  */
}

export const outlines_tamer = {
  'red': outline_tamer_red,
  'blue': outline_tamer_blue,
  'yellow': outline_tamer_yellow,
  'green': outline_tamer_green,
  'purple': outline_tamer_purple,
  'black': outline_tamer_black,
  'white': outline_tamer_white,
}
export const outlines_tamer_nocost = {
  'red': outline_tamer_red_nocost,
  'blue': outline_tamer_blue_nocost,
  'yellow': outline_tamer_yellow_nocost,
  'green': outline_tamer_green_nocost,
  'purple': outline_tamer_purple_nocost,
  'black': outline_tamer_black_nocost,
  'white': outline_tamer_white_nocost,
}

export const effectboxes = {
  'red': effectbox_red,
  'blue': effectbox_blue,
  'yellow': effectbox_yellow,
  'green': effectbox_green,
  'purple': effectbox_purple,
  'black': effectbox_black,
  'white': effectbox_white,
}

let bottom_evo_red = new Image(); bottom_evo_red.src = _bottom_evo_red;
let bottom_evo_blue = new Image(); bottom_evo_blue.src = _bottom_evo_blue;
let bottom_evo_yellow = new Image(); bottom_evo_yellow.src = _bottom_evo_yellow;
let bottom_evo_green = new Image(); bottom_evo_green.src = _bottom_evo_green;
let bottom_evo_purple = new Image(); bottom_evo_purple.src = _bottom_evo_purple;
let bottom_evo_black = new Image(); bottom_evo_black.src = _bottom_evo_black;
let bottom_evo_white = new Image(); bottom_evo_white.src = _bottom_evo_white;

let bottom_evo_egg_red = new Image(); bottom_evo_egg_red.src = _bottom_evo_egg_red;
let bottom_evo_egg_blue = new Image(); bottom_evo_egg_blue.src = _bottom_evo_egg_blue;
let bottom_evo_egg_yellow = new Image(); bottom_evo_egg_yellow.src = _bottom_evo_egg_yellow;
let bottom_evo_egg_green = new Image(); bottom_evo_egg_green.src = _bottom_evo_egg_green;
let bottom_evo_egg_purple = new Image(); bottom_evo_egg_purple.src = _bottom_evo_egg_purple;
let bottom_evo_egg_black = new Image(); bottom_evo_egg_black.src = _bottom_evo_egg_black;
let bottom_evo_egg_white = new Image(); bottom_evo_egg_white.src = _bottom_evo_egg_white;


let bottom_red = new Image(); bottom_red.src = _bottom_red;
let bottom_blue = new Image(); bottom_blue.src = _bottom_blue;
let bottom_yellow = new Image(); bottom_yellow.src = _bottom_yellow;
let bottom_green = new Image(); bottom_green.src = _bottom_green;
let bottom_purple = new Image(); bottom_purple.src = _bottom_purple;
let bottom_black = new Image(); bottom_black.src = _bottom_black;
let bottom_white = new Image(); bottom_white.src = _bottom_white;

/*let bottom_ace_red = new Image(); bottom_ace_red.src = _bottom_ace_red;
let bottom_ace_blue = new Image(); bottom_ace_blue.src = _bottom_ace_blue;
let bottom_ace_yellow = new Image(); bottom_ace_yellow.src = _bottom_ace_yellow;
let bottom_ace_green = new Image(); bottom_ace_green.src = _bottom_ace_green;
let bottom_ace_purple = new Image(); bottom_ace_purple.src = _bottom_ace_purple;
let bottom_ace_black = new Image(); bottom_ace_black.src = _bottom_ace_black;
let bottom_ace_white = new Image(); bottom_ace_white.src = _bottom_ace_white;
*/

let inherited_sec_red = new Image(); inherited_sec_red.src = _inherited_sec_red;
let inherited_sec_blue = new Image(); inherited_sec_blue.src = _inherited_sec_blue;
let inherited_sec_yellow = new Image(); inherited_sec_yellow.src = _inherited_sec_yellow;
let inherited_sec_green = new Image(); inherited_sec_green.src = _inherited_sec_green;
let inherited_sec_purple = new Image(); inherited_sec_purple.src = _inherited_sec_purple;
let inherited_sec_black = new Image(); inherited_sec_black.src = _inherited_sec_black;
let inherited_sec_white = new Image(); inherited_sec_white.src = _inherited_sec_white;

let inherited_sec_mon_red = new Image(); inherited_sec_mon_red.src = _inherited_sec_mon_red;
let inherited_sec_mon_blue = new Image(); inherited_sec_mon_blue.src = _inherited_sec_mon_blue;
let inherited_sec_mon_yellow = new Image(); inherited_sec_mon_yellow.src = _inherited_sec_mon_yellow;
let inherited_sec_mon_green = new Image(); inherited_sec_mon_green.src = _inherited_sec_mon_green;
let inherited_sec_mon_purple = new Image(); inherited_sec_mon_purple.src = _inherited_sec_mon_purple;
let inherited_sec_mon_black = new Image(); inherited_sec_mon_black.src = _inherited_sec_mon_black;
let inherited_sec_mon_white = new Image(); inherited_sec_mon_white.src = _inherited_sec_mon_white;


let bottom_plain_red = new Image(); bottom_plain_red.src = _bottom_plain_red;
let bottom_plain_blue = new Image(); bottom_plain_blue.src = _bottom_plain_blue;
let bottom_plain_yellow = new Image(); bottom_plain_yellow.src = _bottom_plain_yellow;
let bottom_plain_green = new Image(); bottom_plain_green.src = _bottom_plain_green;
let bottom_plain_purple = new Image(); bottom_plain_purple.src = _bottom_plain_purple;
let bottom_plain_black = new Image(); bottom_plain_black.src = _bottom_plain_black;
let bottom_plain_white = new Image(); bottom_plain_white.src = _bottom_plain_white;



let border_red = new Image(); border_red.src = _border_red;
let border_blue = new Image(); border_blue.src = _border_blue;
let border_yellow = new Image(); border_yellow.src = _border_yellow;
let border_green = new Image(); border_green.src = _border_green;
let border_purple = new Image(); border_purple.src = _border_purple;
let border_black = new Image(); border_black.src = _border_black;
let border_white = new Image(); border_white.src = _border_white;

export const bottom_evos = {
  'red': bottom_evo_red,
  'blue': bottom_evo_blue,
  'yellow': bottom_evo_yellow,
  'green': bottom_evo_green,
  'purple': bottom_evo_purple,
  'black': bottom_evo_black,
  'white': bottom_evo_white,
}

export const bottom_egg_evos = {
  'red': bottom_evo_egg_red,
  'blue': bottom_evo_egg_blue,
  'yellow': bottom_evo_egg_yellow,
  'green': bottom_evo_egg_green,
  'purple': bottom_evo_egg_purple,
  'black': bottom_evo_egg_black,
  'white': bottom_evo_egg_white,
}


export const bottoms = {
  'red': bottom_red,
  'blue': bottom_blue,
  'yellow': bottom_yellow,
  'green': bottom_green,
  'purple': bottom_purple,
  'black': bottom_black,
  'white': bottom_white,
}

/*
export const bottom_aces_UNUSED = {
  'red': bottom_ace_red,
  'blue': bottom_ace_blue,
  'yellow': bottom_ace_yellow,
  'green': bottom_ace_green,
  'purple': bottom_ace_purple,
  'black': bottom_ace_black,
  'white': bottom_ace_white
}*/

export const inherited_security = {
  'red': inherited_sec_red,
  'blue': inherited_sec_blue,
  'yellow': inherited_sec_yellow,
  'green': inherited_sec_green,
  'purple': inherited_sec_purple,
  'black': inherited_sec_black,
  'white': inherited_sec_white
}

export const inherited_mon_security = {
  'red': inherited_sec_mon_red,
  'blue': inherited_sec_mon_blue,
  'yellow': inherited_sec_mon_yellow,
  'green': inherited_sec_mon_green,
  'purple': inherited_sec_mon_purple,
  'black': inherited_sec_mon_black,
  'white': inherited_sec_mon_white
}

// NAME field
export const bottoms_plain = {
  'red': bottom_plain_red,
  'blue': bottom_plain_blue,
  'yellow': bottom_plain_yellow,
  'green': bottom_plain_green,
  'purple': bottom_plain_purple,
  'black': bottom_plain_black,
  'white': bottom_plain_white,
}

export const borders = {
  'red': border_red,
  'blue': border_blue,
  'yellow': border_yellow,
  'green': border_green,
  'purple': border_purple,
  'black': border_black,
  'white': border_white,
}


export const classics = {
  'red': classic_red,
  'blue': classic_blue,
  'yellow': classic_yellow,
  'green': classic_green,
  'purple': classic_purple,
  'black': classic_black,
  'white': classic_white,
}


export const eggs = {
  'red': egg_red,
  'blue': egg_blue,
  'yellow': egg_yellow,
  'green': egg_green,
  'purple': egg_purple,
  'black': egg_black,
  'white': egg_white,
}

export const options = {
  'red': option_red,
  'blue': option_blue,
  'yellow': option_yellow,
  'green': option_green,
  'purple': option_purple,
  'black': option_black,
  'white': option_white,
}

export const tamers = {
  'red': tamer_red,
  'blue': tamer_blue,
  'yellow': tamer_yellow,
  'green': tamer_green,
  'purple': tamer_purple,
  'black': tamer_black,
  'white': tamer_white,
}




/* pre BT-14
export const evos = {
  'red': evo_red,
  'blue': evo_blue,
  'yellow': evo_yellow,
  'green': evo_green,
  'purple': evo_purple,
  'black': evo_black,
  'white': evo_white,
}*/


// this function and the next are too similar
export function countColors(str) {
  const colors = ['red', 'blue', 'yellow', 'green', 'purple', 'black', 'white'];
  const regex = new RegExp(`\\b(${colors.join('|')})\\b`, 'ig');
  const matches = [...str.matchAll(regex)].map(match => match[0]);
  return matches;
}

export function getDot(input) {

      if (input.includes("🔴")) return "Red";
      if (input.includes("🔵")) return "Blue";
      if (input.includes("🟡")) return "Yellow";
      if (input.includes("🟢")) return "Green";
      if (input.includes("🟣")) return "Purple";
      if (input.includes("⚫")) return "Black";
      if (input.includes("⚪")) return "White";
      return undefined;
}


export function colorReplace(str, strict) {
  if (!str) return "";
  if (strict) {
    str = str.replaceAll(/\(Red\)/ig, "🔴");
    str = str.replaceAll(/\(Blue\)/ig, "🔵");
    str = str.replaceAll(/\(Yellow\)/ig, "🟡");
    str = str.replaceAll(/\(Green\)/ig, "🟢");
    str = str.replaceAll(/\(Purple\)/ig, "🟣");
    str = str.replaceAll(/\(Black\)/ig, "⚫"); // that's black, really
    str = str.replaceAll(/\(White\)/ig, "⚪");

  } else {
    str = str.replaceAll(/\bRed\b/ig, "🔴");
    str = str.replaceAll(/\bBlue\b/ig, "🔵");
    str = str.replaceAll(/\bYellow\b/ig, "🟡");
    str = str.replaceAll(/\bGreen\b/ig, "🟢");
    str = str.replaceAll(/\bPurple\b/ig, "🟣");
    str = str.replaceAll(/\bBlack\b/ig, "⚫"); // that's black, really
    str = str.replaceAll(/\bWhite\b/ig, "⚪");
  }
  return str;
  // ⬤  ⬤ 🔴 🔶 🟡

}
